export default __webpack_public_path__ + "static/media/Virual-Audits-Active-Icon.46f01b5d.svg";